<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧校园</h2>
        <h3>智慧电子班牌系统</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview">
        <div>
          <h2>智慧电子班牌系统</h2>
          <p>通过安装多功能电子班牌、传达室多功能一体机，打通并连接校园 所有显示屏、将学生刷卡、人脸识别、二维码识别、智能语音等 技术嵌入，实现校园数据“采集、显示、交互”智能化 ，构建智慧 校园 软硬件结合的整体环境。</p>
        </div>
      </div>
    </div>
    <!-- 方案优势 -->
    <div class="container clearfix">
      <div class="smart-title">方案优势</div>
      <ul class="smart-strength clearfix mb100">
        <li>
          <h2>多人脸识别</h2>
          <p>班牌系统可扩展人脸识别功能，支持5个人同时识别，语音播报姓名，并支持 脱机人脸识别可进行现场演示。</p>
        </li>
        <li>
          <h2>直播教室内监控画面</h2>
          <p>班牌系统具备配套教师端、家长端 独立APP及微信公众号</p>
        </li>
        <li>
          <h2>提供不低于20种并支持断网脱机</h2>
          <p>视频、图片、课表、学生信息全部功能在脱机下运行。脱机时保证刷卡考勤及 抓拍数据的完整性，联网自动上传并提供现场演示</p>
        </li>
        <li>
          <h2>手环</h2>
          <p>能够支持学生手环功能，学生打卡，自动将运动步数等信息上传。</p>
        </li>
        <li>
          <h2>智慧控制</h2>
          <p>能够开关教室灯光、空调、通风、投影仪等设备。</p>
        </li>
        <li>
          <h2>系统支持断网脱机运行</h2>
          <p>包括视频、图片、课表、学生信息全部功能在脱机下运行。脱机时保证刷卡 考勤及抓拍数据的完整性，联网自动上传并提供现场演示。</p>
        </li>
        <li>
          <h2>云平台、本地私有化平台</h2>
          <p>能够实现云平台及本地私有化平台多种部署模式。</p>
        </li>
        <li>
          <h2>可对接一卡通系统平台</h2>
          <p>可对接校园一卡通系统（包括校园宿舍管理、门禁系统、考勤系统、食堂消 费系统、图书馆系统、课程管理系统、预约系统等相关系统）。</p>
        </li>
        <li>
          <h2>多界面展示功能</h2>
          <p>可根据校园不同需求展现不同界面，实现超高清的视觉设计和操作体验。</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Sswisdomclasscard',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/background_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.smart-strength {
  display: table;
  margin-right: -132px;
}
.smart-strength li {
  float: left;
  width: 366px;
  height: 160px;
  margin-right: 41px;
  margin-bottom: 50px;
}
.smart-strength li h2 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.smart-strength li p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
</style>
